export function addUnique(values: string[], value: string): string[] {
  return values.includes(value) ? values : [...values, value];
}

export function removeValue(values: string[], value: string): string[] {
  return values.filter((x) => x !== value);
}

export function toggleValue(values: string[], value: string, nextChecked: boolean): string[] {
  return nextChecked ? addUnique(values, value) : removeValue(values, value);
}
